import React, { FC } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import NftCard from "../../album/albumDetail/tabs/nftCard";
import { NFTExport } from "../../../models/exports";
import Loading from "../../loading/loading";

interface GalleryTabProps {
  loading: boolean;
  combinedNFTs: NFTExport[];
}

const GalleryTab: FC<GalleryTabProps> = ({ loading, combinedNFTs }) => {
  if (loading) {
    return (
      <div className="flex flex-col h-full place-content-center">
        <div className="mt-16 mx-auto">
          <Loading size={32} />
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex flex-col flex-grow fade-in"
      style={{ minHeight: "60vh" }}
    >
      {(!combinedNFTs || combinedNFTs.length === 0) && (
        <div className="flex flex-row justify-center pt-16 md:pt-64">
          <p className="body1 text-dark-white-64">
            No NFTs owned on this wallet
          </p>
        </div>
      )}
      <div className="flex flex-col flex-grow pb-16 md:pb-32">
        {combinedNFTs && combinedNFTs.length > 0 && (
          <ResponsiveMasonry
            columnsCountBreakPoints={{ 319: 1, 767: 2, 1439: 3 }}
          >
            <Masonry gutter="20px">
              {combinedNFTs.map((nft) => (
                <NftCard nft={nft} key={nft.id} />
              ))}
            </Masonry>
          </ResponsiveMasonry>
        )}
      </div>
    </div>
  );
};

export default GalleryTab;
